/******************************************************************************
 * ProfilePage Hook
 * version: 1.0.1, release: 10.06.2019
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/


import React, { useState } from 'react';
import { Page } from '../components/ui/Page';
import Store from '../store/Store';
import { List } from '../components/ui/List';
import { Body } from '../components/layout/Body';



interface PageProps {
	id?: string;
	className?: string;
}


//============================================================================= ProfilePage Hook
interface ProfilePageProps extends PageProps {
	id: string;
}

export default function ProfilePage(props: Readonly<ProfilePageProps>) {
	const user = Store.user
	const twoFactorVerified = Store.use('twoFactorVerified')
	const twoFactorRequired = Store.use('twoFactorRequired')
	const [resetCode, setResetCode] = useState('')
	const [busy, setBusy] = useState(false)

	if (!user) {
		return <Page id={props.id}>
			<Body title='Profile'><p>User not found.</p></Body>
		</Page>;
	}

	const onReset2fa = async () => {
		setBusy(true)
		try {
			const res = await Store.fetch(
				'2fa/reset',
				{
					method: 'POST',
					body: JSON.stringify({ code: resetCode }),
				},
				false,
				true
			)

			if (res) {
				Store.set({ twoFactorVerified: false, twoFactorRequired: true })
				setResetCode('')
				Store.navigate('/2fa')
			}
		} finally {
			setBusy(false)
		}
	}

	return (
		<Page id={props.id} className={props.className}>
			<Body title='Profile'>
				<h3>Ihre Angaben</h3>

				<List content={{
					"Vorname": user.firstName,
					"Nachname": user.lastName,
					"Email-Addresse": user.email,
					"Username": user.username
				}} />

				{twoFactorRequired && !!user.twoFactorEnabled && (
					<div className="mt-8">
						<h3>2-Faktor-Authentifizierung</h3>

						{!twoFactorVerified && (
							<p className="mb-3">
								Sie sind derzeit nicht verifiziert. Bitte schließen Sie zuerst die 2FA-Verifizierung ab.
							</p>
						)}

						<div className="flex flex-col gap-3 max-w-xs">
							<input
								value={resetCode}
								onChange={(e) => setResetCode(e.target.value)}
								placeholder="000000"
								inputMode="numeric"
								className="w-full max-w-xs rounded-[20px] border border-[#333] px-3 py-2 text-area"
							/>
							<button
								className="bg-gray-300 text-black px-4 py-2 rounded-md"
								onClick={onReset2fa}
								disabled={!twoFactorVerified || busy || resetCode.trim().length < 6}
							>
								2FA zurücksetzen
							</button>
						</div>
					</div>
				)}

			</Body>
		</Page>
	);
}

